import {SVGProps} from "react";

export default function LogoFull(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="308"
      height="66"
      viewBox="0 0 308 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M296.553 60.6401V1.12012H307.673V60.6401H296.553Z" fill="currentColor" />
      <path
        d="M236.251 60.6401L257.851 1.12012H269.691L291.371 60.6401H279.531L274.811 46.4801H252.251L247.451 60.6401H236.251ZM259.691 24.5601L254.971 38.3201H272.091L267.531 24.5601C265.211 17.5201 263.771 10.2401 263.771 10.2401H263.611C263.611 10.2401 261.611 18.8801 259.691 24.5601Z"
        fill="currentColor"
      />
      <path
        d="M200.858 17.9203V25.6003H201.098C203.818 20.0803 207.898 17.2803 213.338 17.2803C214.538 17.2803 215.338 17.3603 216.058 17.6803V26.8003H215.738C214.778 26.5603 213.978 26.4803 212.938 26.4803C206.218 26.4003 201.178 30.9603 201.178 39.2003V60.6403H191.018V17.9203H200.858Z"
        fill="currentColor"
      />
      <path
        d="M167.146 62.0001C161.466 62.0001 156.586 59.5201 154.026 54.4801H153.786V60.6401H143.946V1.12012H154.106V15.2001C154.106 18.5601 153.946 22.0001 153.786 24.2401H154.026C156.826 19.7601 161.146 16.8001 167.226 16.8001C178.186 16.8001 185.546 25.7601 185.546 39.3601C185.546 53.2801 178.506 62.0001 167.146 62.0001ZM164.986 53.6801C171.786 53.6801 175.226 47.8401 175.226 39.2801C175.226 30.8801 171.786 24.7201 164.986 24.7201C157.226 24.7201 153.706 31.2001 153.706 39.3601C153.706 47.6801 157.626 53.6801 164.986 53.6801Z"
        fill="currentColor"
      />
      <path
        d="M126.011 10.9601V1.12012H136.411V10.9601H126.011ZM126.171 60.6401V17.9201H136.331V60.6401H126.171Z"
        fill="currentColor"
      />
      <path d="M108.166 60.6401V1.12012H118.406V60.6401H108.166Z" fill="currentColor" />
      <path
        d="M91.973 60.6398C91.253 59.6798 90.693 57.9998 90.533 55.1198H90.373C87.573 58.8798 83.733 61.6798 76.933 61.6798C68.613 61.6798 62.373 57.3598 62.373 49.0398C62.373 39.3598 69.733 37.0398 79.893 35.8398C86.933 34.9598 90.453 33.8398 90.453 29.9998C90.453 26.3198 87.893 23.8398 82.773 23.8398C77.093 23.8398 74.293 26.4798 74.053 30.7198H64.453C64.773 23.4398 70.533 16.7998 82.693 16.7998C87.573 16.7998 91.333 17.5198 94.133 19.2798C98.133 21.6798 100.213 25.7598 100.213 31.4398V53.9198C100.213 57.4398 100.853 59.2798 101.813 59.9198V60.6398H91.973ZM79.893 54.7198C86.853 54.7198 90.693 49.9198 90.693 45.1198V38.7998C88.693 40.0798 85.493 40.9598 82.373 41.5998C76.133 42.7998 72.533 44.0798 72.533 48.7998C72.533 53.3598 75.973 54.7198 79.893 54.7198Z"
        fill="currentColor"
      />
      <path
        d="M53.28 65.76L44.48 58.16C40.24 60.64 35.12 62 29.28 62C11.2 62 0 48.8 0 31.04C0 13.2 11.2 0 29.28 0C47.28 0 58.48 13.2 58.48 31.04C58.48 40 55.6 47.76 50.56 53.28L58.4 60.08L53.28 65.76ZM29.28 52.88C32.08 52.88 34.56 52.4 36.72 51.44L29.36 44.96L34.4 39.2L42.8 46.56C45.68 42.64 47.12 37.28 47.12 31.04C47.12 18.64 41.04 9.12 29.28 9.12C17.44 9.12 11.28 18.64 11.28 31.04C11.28 43.36 17.44 52.88 29.28 52.88Z"
        fill="currentColor"
      />
    </svg>
  );
}
